import React from 'react';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { spinner as Spinner } from 'ui/views/generic/spinner';
 *
 * // render
 * <Spinner propName='propValue'/>
 */
export const spinner = ( props ) => {

	const style = {
		width: `${ props.radius }px`,
		height: `${ props.radius }px`
	};
    return (
        <div className='ui-button-preloader' style = { style }/>
    );
};

// set display name
spinner.displayName = 'spinner';

// set default props
spinner.defaultProps = {
	radius: 20
};

// prop types
spinner.propTypes = {};
